import React from 'react'


export default function CommitModal({windowHeight, leftMargin, count,changesLeft }) {



  return (
    <div className='overlay-modal' style={{position:'fixed',display:'flex',justifyContent:'center',top: windowHeight > 1000 ? '69px' : '0px',left:leftMargin,width:windowHeight > 1000 ? '1858px': '1920px',height:'94vh', backgroundColor:'rgba(0,0,0,0.5)',zIndex:100,overflowY:'auto'}}>
         <div className='overlap-content' style={{height:'500px',marginTop:'10%'}}>
            <div style={{padding:'20%'}}><p style={{fontSize:'30px'}}>{changesLeft}</p></div>          
         </div>
       </div>
  )
}
